import { cn } from "@/lib/cn";
import { useIntersectionObserver } from "usehooks-ts";
import { SandboxedHtml } from "./SandboxedHtml";

const Code = ({ code, isEditor }: { code: string; isEditor: boolean }) => {
  const { isIntersecting, ref } = useIntersectionObserver({
    threshold: 0.5,
    freezeOnceVisible: true,
    rootMargin: "200px",
  });
  if (!code) return null;
  return (
    <div
      ref={ref}
      className={cn("code tw-h-full tw-w-full", {
        "tw-pointer-events-none": isEditor,
      })}
    >
      <SandboxedHtml
        code={isIntersecting ? code : ""}
        title="Embedded content"
        tabIndex={-1}
        className="tw-h-full tw-w-full tw-border-0"
        loading="lazy"
      />
    </div>
  );
};

export default Code;
